import { render, staticRenderFns } from "./TwelveLaboursHeader.vue?vue&type=template&id=3eb6b98a&scoped=true&"
import script from "./TwelveLaboursHeader.vue?vue&type=script&lang=js&"
export * from "./TwelveLaboursHeader.vue?vue&type=script&lang=js&"
import style0 from "./TwelveLaboursHeader.vue?vue&type=style&index=0&id=3eb6b98a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb6b98a",
  null
  
)

export default component.exports